import React, { useEffect, useRef } from 'react';
import { notification } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NotificationStreamService from '../../services/notificationStream';
import { toLower } from 'lodash';
import { TRANSACTION_HISTORY_MODULES as MODULES } from '../constants/commonConstants';

const NotificationListener = ({ history, moduleId }) => {
  const serviceRef = useRef(null);

  useEffect(() => {
    const service = new NotificationStreamService({
      moduleId,
      onMessage: (event) => {
        if (event.eventType !== 'async_download') return;
        console.log('Notification received:', event);

        const {
          status,
          exportName,
          errorReason,
          alertId,
          caseId,
          partyId,
          downloadType,
          module,
          customerId
        } = event;

        const navigateToDownloadHistory = () => {
          if (downloadType === 'case') {
            history.push({
              pathname: `/app/cm/cases-by-department/${caseId}/take-action`,
              search: '?downloadHistory=true'
            });
          } else if (
            module === MODULES.CM_CASE_TRANSACTION_HISTORY &&
            caseId
          ) {
            // Generic case-level transaction download (no specific TM/CRS subtype)
            history.push({
              pathname: `/app/cm/cases-by-department/${caseId}`,
              search: '?downloadHistory=true'
            });
          } else if (
            (module === MODULES.CM_CASE_TM_TRANSACTION_HISTORY ||
              module === MODULES.CM_CASE_CRS_TRANSACTION_HISTORY) &&
            caseId
          ) {
            // Case-level TM/CRS export — go to case page, select the alert tab, open download history
            history.push({
              pathname: `/app/cm/cases-by-department/${caseId}`,
              search: `?alertId=${alertId}&tab=downloadHistory`
            });
          } else if (alertId) {
            if (
              module === MODULES.CM_TM_TRANSACTION_HISTORY ||
              module === MODULES.CM_CRS_TRANSACTION_HISTORY
            ) {
              history.push({
                pathname: `/app/cm/alerts/${alertId}`,
                search: '?tab=downloadHistory'
              });
            } else if (module === MODULES.TM_TRANSACTION_HISTORY) {
              history.push({
                pathname: `/app/trm/run-instance/${alertId}`,
                search: '?tab=downloadHistory'
              });
            } else if (module === MODULES.CRS_TRANSACTION_HISTORY) {
              history.push({
                pathname: `/app/crs/details/${partyId || customerId}`,
                search: '?tab=downloadHistory'
              });
            } else if (
              module === MODULES.CM_MANUAL_CUSTOMER_TRANSACTION_HISTORY ||
              module === MODULES.CM_MANUAL_CASE_TRANSACTION_HISTORY
            ) {
              history.push({
                pathname: `/app/cm/cases-by-department/${caseId}`,
                search: `?customerId=${partyId || customerId}&tab=downloadHistory`
              });
            }
          }
          notification.destroy();
        };

        const statusLower = toLower(status);
        const notifyConfig = {
          completed: {
            type: 'success',
            message: 'Export Completed',
            description: exportName
          },
          inprogress: {
            type: 'info',
            message: 'Export Inprogress',
            description: exportName
          },
          failed: {
            type: 'error',
            message: 'Export Failed',
            description: errorReason || exportName
          }
        };

        // Trigger refresh of download history if user is on the corresponding page
        if (
          (module === MODULES.CM_CASE_TRANSACTION_HISTORY || downloadType === 'case') &&
          caseId
        ) {
          // Signal to DownloadTransactionsDrawer on take-action page to refresh
          // Store notification trigger time keyed by caseId
          sessionStorage.setItem(
            `download_refresh_${caseId}`,
            JSON.stringify({
              module,
              caseId,
              timestamp: new Date().toISOString()
            })
          );
        }

        const config = notifyConfig[statusLower];
        if (config) {
          notification[config.type]({
            message: config.message,
            description: config.description,
            duration: 8,
            placement: 'topRight',
            onClick: navigateToDownloadHistory,
            style: { cursor: 'pointer' }
          });
        }
      },
      onError: (error) => {
        console.warn('Notification stream error:', error);
      }
    });

    serviceRef.current = service;
    service.connect();

    return () => {
      service.disconnect();
    };
  }, [history, moduleId]);

  return null;
};

const mapStateToProps = (state) => ({
  moduleId: state.authentication?.currentProductLogin?.moduleId
});

export default connect(mapStateToProps)(withRouter(NotificationListener));
